<template>
  <div
    class="switch-camera-btn"
    @click="$emit('click')"
    @touchstart="isPressed = true"
    @touchend="isPressed = false"
    @touchcancel="isPressed = false"
    @mousedown="isPressed = true"
    @mouseup="isPressed = false"
    @mouseleave="isPressed = false"
  >
    <!-- the pressed artwork only exists for the default brand -->
    <img
      :src="brandAsset(switchCamera, switchCameraSanne)"
      :class="{ pressed: isPressed && !isSanne }"
    />
  </div>
</template>

<script>
import brandMode from '@/mixins/brand-mode';
import switchCamera from '@/assets/common/switch-camera.svg';
import switchCameraSanne from '@/assets/sanne/icons/switch-camera.svg';

export default {
  name: 'SwitchCameraButton',
  mixins: [brandMode],
  data: () => ({
    isPressed: false,
    switchCamera,
    switchCameraSanne,
  }),
};
</script>

<style lang="scss" scoped>
.switch-camera-btn {
  img {
    width: 60px;
    height: 45px;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;

    &.pressed {
      content: url('../../assets/common/switch-camera-pressed.svg');
    }
  }
}
</style>
